<template>
    <div style="width: 100%; position: relative" class="parentTitle">
        <h3 class="is-subtitle" v-if="!isMobile">
            Titel
            <InfoPopover
                info="Eine kurze, aussagekräftige Überschrift für den
                    Eintrag."
                example="„Gespräch mit der Schule“ oder „Rückkehr aus
                    dem Wochenende“"
            />
            <span
                class="tag is-danger is-light header-badge"
                v-if="!$v.entryTitle.required"
            >
                Titel benötigt! Bitte geben Sie dem Eintrag eine kurze
                Überschrift.
            </span>
        </h3>
        <b-input
            maxlength="80"
            placeholder="Titel"
            id="entryTitle"
            v-model="entryTitle"
            v-on:input="$v.entryTitle.$touch"
            autocomplete="off"
            type="search"
            :size="isMobile ? 'is-small' : ''"
            @input="edit()"
        ></b-input>
        <!-- On mobile there is no header row, keep the badge below. -->
        <div
            class="tag is-danger is-light padded dangerTag"
            v-if="isMobile && !$v.entryTitle.required"
        >
            Titel benötigt! Bitte geben Sie dem Eintrag eine kurze
            Überschrift.
        </div>
    </div>
</template>

<script>
/**
 * Component for creation of a title on an entry.
 * @displayName DiaryTitle
 */

import { required } from "vuelidate/lib/validators";
import InfoPopover from "@/components/helper/InfoPopover";

export default {
    name: "DiaryTitle",
    components: { InfoPopover },
    props: ["diaryTitle", "setTitle", "editEntry"],
    data() {
        return {};
    },
    validations: {
        entryTitle: { required },
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        },
        entryTitle: {
            set(value) {
                this.setTitle(value);
            },
            get() {
                return this.diaryTitle;
            },
        },
    },
    methods: {
        edit() {
            if (this.editEntry) this.editEntry();
        },
    },
};
</script>


<style lang="scss" scoped>
.attribute_titel {
    font-weight: bold;
    margin: 1rem 0rem 0.25rem 0rem;
    //color: #5b7a99;
}

h3.is-subtitle {
    display: flex;
    align-items: center;
    gap: 0.35em;
}

/* Right-aligned in the header row on wide screens. */
.header-badge {
    margin-left: auto;
    font-weight: normal;
    white-space: normal;
    height: auto;
}

.parentTitle {
    min-height: 0;
    padding-top: 0.5rem;
}

.parentTitle .dangerTag {
    position: absolute;
    left: 0;
    bottom: -0.5rem;
    margin: 0;
}

::v-deep .input {
    border-radius: 6px;
}

div.vgs__container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.padded {
    margin-top: 6px;
    margin-bottom: 6px;
}
.field:not(:last-child) {
    margin-bottom: 0;
}

@media (max-width: 769px) {
    .parentTitle {
        min-height: 60px;
        margin-bottom: 0.5rem;
    }
    .padded {
        padding: 0.25rem;
        margin: 0;
    }
}
</style>
